import React from 'react';

import { Painel } from '../Painel';
import { Icon } from '../Icon';
import { colors } from '../../styles/tokens';
import { Container, Subtitle, Title } from './styles';

// Conteúdo em si, sem o `<Painel>` -- reutilizável tanto pra bloquear a
// rota inteira (ver `LockedFeaturePage` abaixo) quanto embutido dentro
// de uma página que já abriu seu próprio `<Painel>` e só quer bloquear
// uma seção (ex.: Relatórios, que mistura seções com features
// diferentes). Texto genérico de propósito -- não fala em "plano": o
// que libera pode ser upgrade, mas também addon concedido pela
// plataforma, então a mensagem fala só da falta de acesso em si.
const LockedFeatureContent: React.FC = () => (
  <Container>
    <Icon name="lock" size={40} color={colors.onSurfaceVariant} />
    <Title>Acesso não disponível</Title>
    <Subtitle>
      Esta página não está disponível para a sua academia no momento. Fale com
      o suporte para saber como liberar o acesso.
    </Subtitle>
  </Container>
);

// Renderizado no lugar da página real quando `AuthRoute` barra por
// `requiredFeature` -- item de menu já mostra cadeado antes do clique
// (ElementMenu), então clicar precisa levar pra algo consistente com
// isso, não te devolver pro dashboard silenciosamente.
const LockedFeaturePage: React.FC = () => (
  <Painel loading={false}>
    <LockedFeatureContent />
  </Painel>
);

export { LockedFeaturePage, LockedFeatureContent };
